import { Descriptions, Spin } from 'antd'

import { useSimeTbServiceGetSimeTbPersonByIdEndpoint } from 'src/api/queries'
import { Permissions } from 'src/api/requests'
import { useUser } from 'src/hooks'
import { useLocales } from 'src/locales'

type Props = {
  simeTbExternalId: string
}

/**
 * Reads back the TB-system institution/doctor assigned to a transmitted person
 * via GET sime-tb/persons/by-id/{id}. HIV staff can only read these; they are
 * null until the TB staff assigns the case.
 */
export const TbCaseReadback = ({ simeTbExternalId }: Props) => {
  const { t } = useLocales()
  const { hasPermission } = useUser()

  const canView = hasPermission(Permissions.INTEGRATIONS_SIME_TB_PERSONS_VIEW)

  const { data, isLoading } = useSimeTbServiceGetSimeTbPersonByIdEndpoint(
    { id: simeTbExternalId },
    [simeTbExternalId],
    { enabled: canView && !!simeTbExternalId }
  )

  if (!canView) return null

  if (isLoading) return <Spin size="small" />

  const doctorName = data?.doctor
    ? [data.doctor.lastName, data.doctor.firstName].filter(Boolean).join(' ')
    : null

  return (
    <Descriptions size="small" column={1}>
      <Descriptions.Item label={t('screening_tb.tb_institution')}>
        {data?.institution?.name ?? t('screening_tb.not_assigned')}
      </Descriptions.Item>
      <Descriptions.Item label={t('screening_tb.tb_doctor')}>
        {doctorName ?? t('screening_tb.not_assigned')}
      </Descriptions.Item>
    </Descriptions>
  )
}
